/* eslint class-methods-use-this: 0 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, DropdownButton, MenuItem, Row, Col, Glyphicon } from 'react-bootstrap';
import _ from 'underscore';
import moment from 'moment';
import { withTranslation } from 'react-i18next';


class AddContactModal extends Component {
  state = {
    name: "",
    phone: "",
    email: "",
  }

  handleChange = (field) => (e) => {
    this.setState({[field]: e.target.value})
  }

  onSubmit = () => {
    this.props.addContact(this.state);
  }


  render() {
    return (
      <Modal show={this.props.show} onHide={() => this.props.onHide()} enforceFocus={false}>
        <Modal.Header>
          <Modal.Title>
            {t('ADD_CONTACT')}
          </Modal.Title>
        </Modal.Header>
				<Modal.Body>
          <Row>
            <Col xs={4}>
              <input
                placeholder="Name"
                className="w-full mb-4 block form-field"
                onChange={this.handleChange('name')}
              />
            </Col>
            <Col xs={4}>
              <input
                placeholder="Phone"
                className="w-full mb-4 block form-field"
                onChange={this.handleChange('phone')}
              />
            </Col>
            <Col xs={4}>
              <input
                placeholder="Email"
                className="w-full mb-4 block form-field"
                onChange={this.handleChange('email')}
              />
            </Col>
          </Row>
				</Modal.Body>
				<Modal.Footer>
					<Row>
						<Col xs={8}></Col>
						<Col xs={2}>
              <button
                className="button button-green"
                disabled={!this.state.name.length}
                onClick={this.onSubmit}
              >
                {t('SUBMIT')}
              </button>
						</Col>
            <Col xs={2}>
              <button
                className="block button secondary-action"
                onClick={() => this.props.onClose()}
              >
                {t('CANCEL')}
              </button>
            </Col>
					</Row>
				</Modal.Footer>
			</Modal>
    );
  }
}

export default  withTranslation()(AddContactModal);
